import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=0fa0c387&"
import script from "./CompanySettings.vue?vue&type=script&lang=ts&"
export * from "./CompanySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports